<!--
 * @Author: Lemon C
 * @Date: 2024-05-10 10:38:09
 * @LastEditTime: 2025-03-13 11:37:58
-->
<template>
    <div class="sup-bady" @mousemove="listen_mouse_move" @mouseup="listen_mouse_up">
        <DocsTree
            class="docs-tree"
            :style="{ width: tree_fold_width + '%' }"
            :request_gourp="curr_docs_type"
            :share_url_data="shareData"
            :tree_node_callback="tree_node_callback"></DocsTree>
        <WebCode
            class="web-demo-code"
            ref="ref_web_code"
            v-if="eltree_sel_data.id"
            :comp_tree_node_id="eltree_sel_data.id"
            :comp_tree_node_name="eltree_sel_data.name"
            :code_comp_update_data="code_comp_update_data"
            :code_comp_fold_callback="code_comp_fold_callback"></WebCode>
        <div class="web-demo-split-line" @mousedown="listen_mouse_down"></div>
        <WebIframe class="web-demo-iframe" ref="ref_web_iframe"></WebIframe>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onBeforeMount, getCurrentInstance, nextTick } from 'vue';
import DocsTree from '@/components/Tree/DocsTree.vue';
import WebCode from '@/components/Demo/WebCode.vue';
import WebIframe from '@/components/Demo/WebIframe.vue';
import { useRouterStore } from '@/stores/router';

const router_store = useRouterStore();
const { proxy } = getCurrentInstance();

const ref_web_code = ref(null);
const ref_web_iframe = ref(null);
const curr_docs_type = ref(proxy.$globalObj.group.demo); //当前请求类型
const shareData = ref({}); //分享链接数据
const eltree_sel_data = ref({}); //目录树选中节点
const tree_fold_width = ref(20); //默认目录树宽度比例
const mouseDown = ref(false); //鼠标按下
const mouseDownX = ref(0); //鼠标移动x坐标
const codeBoxWidth = ref(0); //codeBox宽度
const previewBoxWidth = ref(0); //渲染宽度

onBeforeMount(() => {
    let queryDate = proxy.$route.query;
    if (queryDate && queryDate.shareType && queryDate.shareType == 1) {
        shareData.value = queryDate;
        console.log('分享数据 -- ', queryDate);
    }
});

// MARK Tree  节点点击
const tree_node_callback = (data, treeList) => {
    eltree_sel_data.value = data;

    let queryDate = proxy.$route.query;
    if (!(queryDate && queryDate.shareType && queryDate.shareType == 1 && queryDate.treeId && queryDate.treeId == data.id)) {
        router_store.configBrowserAddressRoute({ shareType: 1, treeId: data.id });
    }
};
// MARK Code 更新数据
const code_comp_update_data = (web_iframe_post_msg) => {
    ref_web_iframe.value.iframe_update(web_iframe_post_msg);
};
// MARK Code 目录树折叠
const code_comp_fold_callback = (eltree_fold) => {
    tree_fold_width.value = eltree_fold ? 0 : 23;
};
// MARK 监听  鼠标按下
const listen_mouse_down = (e) => {
    mouseDown.value = true;
    mouseDownX.value = e.clientX;
    codeBoxWidth.value = ref_web_code.value.$el.clientWidth;
    previewBoxWidth.value = ref_web_iframe.value.$el.clientWidth;
};
// MARK 监听  鼠标移动
const listen_mouse_move = (e) => {
    if (!mouseDown.value) return false;
    let deltaX = e.clientX - mouseDownX.value;
    ref_web_code.value.$el.style.width = `${codeBoxWidth.value + deltaX}px`;
    ref_web_iframe.value.$el.style.width = `${previewBoxWidth.value - deltaX}px`;

    ref_web_iframe.value.$refs.ref_iframe.style.pointerEvents = 'none';
};
// MARK 监听  鼠标抬起
const listen_mouse_up = () => {
    mouseDown.value = false;

    ref_web_code.value.$el.style.zIndex = 'auto';
    ref_web_iframe.value.$refs.ref_iframe.style.pointerEvents = 'auto';
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-bady {
    height: 100%;
    overflow: hidden;
    background-color: var(--color-main-light-bg-white);

    .web-demo-code {
        width: 28%;
    }

    .web-demo-split-line {
        width: 3px;
        height: 100%;
        background: var(--color-main-doc-segmentation-line-bg);
        cursor: col-resize;
    }

    .web-demo-iframe {
        flex: 1;
    }
}
</style>
